import React from 'react';

export default () => {
    return (
        <p>Hi this is ImportRemitReceipt.Home</p>
    )
}